import { useNavigate } from 'react-router-dom-v6'

import { NetworkEditForm, type NetworkFormValues } from '../components/NetworkEditForm'
import { useRegisterNetwork } from '../hooks'

export function RegisterNetwork() {
  const navigate = useNavigate()
  const { mutateAsync: register } = useRegisterNetwork()

  const onSubmit = async (values: NetworkFormValues) => {
    await register(values)
    navigate('/networks')
  }

  return <NetworkEditForm onSubmit={onSubmit} />
}
